import React from 'react'
import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import prop from 'ramda/src/prop'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import injectSheet from 'react-jss'
import style from './style'
import moveToSearchLocation from 'helpers/map/moveToSearchLocation'
import { checkLocationSearchAction } from 'actions/uiActions'

const mapStateToProps = state => {
  return {
    map: createSelector(
      prop('map'),
      prop('ref')
    )(state)
  }
}

class LocationSearch extends React.Component {
  state = { showInput: false }

  constructor(props) {
    super(props)
    this.autocomplete = null
  }

  componentDidMount = _ => {
    const { props: { map, checkLocationSearchAction }, refs: { input }, hideInputDisplay } = this

    const autocomplete = new google.maps.places.Autocomplete(input)
    map && autocomplete.bindTo('bounds', map)
    autocomplete.setFields(['adr_address', 'geometry'])

    google.maps.event.addListener(autocomplete, 'place_changed', _ => {
      const place = autocomplete.getPlace()
      if (!place.geometry) return

      const distance = google.maps.geometry.spherical.computeDistanceBetween(place.geometry.location, this.props.map.getCenter())
      moveToSearchLocation(place, this.props.map)

      if (distance > 200) checkLocationSearchAction()

      hideInputDisplay()
      input.value = ""
    })

    this.autocomplete = autocomplete
  }

  componentDidUpdate = _ => {
    const { props: { map }, state: { showInput }, handleClick } = this

    map && this.autocomplete.bindTo('bounds', map)
    showInput ? document.addEventListener('click', handleClick) : document.removeEventListener('click', handleClick)
  }

  componentWillUnmount = _ => document.removeEventListener('click', this.handleClick)

  showInputDisplay = _ => {
    this.setState(
      { showInput: true },
      _ => this.refs.input.focus()
    )
  }

  hideInputDisplay = _ => {
    this.setState({ showInput: false })
  }

  handleClick = event => {
    if (this.refs.input && this.refs.input.contains(event.target)) {
      return
    }
    this.setState({ showInput: false })
  }

  render = _ => {
    const { showInputDisplay, props: { classes }, state: { showInput } } = this

    return (
      <div className={classes.container}>
        <div className={showInput ? classes.hide : classes.show}>
          <a onClick={showInputDisplay} className={classes.changeLocationButton}>
            <FontAwesomeIcon icon='search' className={classes.searchIcon} />
            Change Location
          </a>
        </div>
        <input className={showInput ? classes.showInput : classes.hideInput} type='text' placeholder='Enter a new location' ref='input' />
        <FontAwesomeIcon icon='times' className={showInput ? classes.showClose : classes.hideClose} />
      </div>
    )
  }
}

export default connect(mapStateToProps, { checkLocationSearchAction })(injectSheet(style)(LocationSearch))



// WEBPACK FOOTER //
// ./src/components/LocationSearch/index.js